module.exports = __webpack_public_path__ + "img/tarj-1.37aedaf2.svg";